export default "__VITE_ASSET__C$9RpE18__"